import { usePrincipal } from '../application/authentication'
import { CustomerAccount } from '../domain'
import { tDefaults, useWriskTranslation } from '../infrastructure/internationalisation'
import { useApiErrorHandlingAsyncCallback } from './auth'

export const useSetupMandate = (customerAccount: CustomerAccount, context?: string) => {
  const { t, i18n } = useWriskTranslation()

  const { apiClient } = usePrincipal()

  return useApiErrorHandlingAsyncCallback(async () => {
    const url = new URL(window.location.href)

    if (context) {
      url.searchParams.set('context', context)
    }

    const redirectFlow = await apiClient.createRedirectFlow({
      policyNumber: customerAccount.accountCode,
      mandateDescription: t(tDefaults('payment-methods.description')),
      successUrl: url.toString(),
      locale: i18n.language,
    })

    window.location.href = redirectFlow.redirectUrl
  })
}
